export const nob = [
  { name: "Fintech" },
  { name: "Ecommerce" },
  { name: "Delivery & Logistics" },
  { name: "FMCG" },
  { name: "Global Business" },
  { name: "Retail Outlet" },
  { name: "Money Transfer Business" },
  { name: "Remittance" },
  { name: "High-Risk Business(Betting, Gaming, Forex)" },
  { name: "Educational Institutions" },
  { name: "Tourism & Hospitality" },
  { name: "Utility Company" },
  { name: "Agriculture" },
  { name: "Healthcare" },
  { name: "Real Estate" },
  { name: "Manufacturing" },
  { name: "Media & Entertainment" },
  { name: "Professional Services" },
  { name: "Information Technology" },
  { name: "Telecommunications" },
  { name: "Construction" },
  { name: "Energy" },
  { name: "Automotive" },
  { name: "Pharmaceuticals" },
  { name: "Non-Profit & NGOs" },
  { name: "Public Sector" },
  { name: "Mining" },
  { name: "Aerospace & Defense" },
  { name: "Consulting" },
  { name: "Financial Services" },
  { name: "Insurance" },
  { name: "Legal Services" },
  { name: "Accounting" },
  { name: "Advertising & Marketing" },
  { name: "Food & Beverage" },
  { name: "Textiles & Apparel" },
  { name: "Transportation" },
  { name: "Waste Management" },
  { name: "Renewable Energy" },
  { name: "Biotechnology" },
  { name: "Cybersecurity" },
  { name: "Petrochemicals" },
  { name: "Sports & Recreation" },
  { name: "Arts & Culture" },
  { name: "Event Planning" },
  { name: "Human Resources" },
  { name: "Recruitment" },
  { name: "Luxury Goods" },
  { name: "Interior Design" },
  { name: "Logistics" },
  { name: "Marine & Shipping" },
  { name: "Chemical Industry" },
  { name: "Machinery & Equipment" },
  { name: "Printing & Publishing" },
  { name: "Security Services" },
  { name: "Electronics" },
  { name: "Software Development" },
  { name: "Research & Development" },
  { name: "Retail Banking" },
  { name: "Wholesale" },
  { name: "Travel Agency" },
];
